<template>
    <div class="text-center">
        <!-- <v-alert dense outlined type="error" v-if="alertError">
            No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
        </v-alert>             -->         
        <v-alert :value="alertErrorPost"
                type="error"
                outlined
                transition="scale-transition"
                color="deep-orange">
                <h4>Errores:</h4>
                <ul>
                    <li type="disc" v-for="(i) in arrayErrorPost" :key="i.value">
                        <h6>{{i.description}}</h6>
                    </li>
                </ul>
        </v-alert>              
        <v-toolbar title elevation="1">
            <v-icon color="black" left>fas fa-tools</v-icon>
            <v-toolbar-title class="">Herramientas disponibles</v-toolbar-title>
            <v-divider vertical class="ml-3"></v-divider>    

            <v-spacer></v-spacer>      
            <v-text-field outlined class=" pr-4"
                label="Buscar Registro"
                v-model="buscarRegistro"
                append-icon="mdi-magnify"
                single-line
                hide-details
            ></v-text-field>
            <BotonActualizarTabla @Actualizartabla="ObtenerTodasLasHerramientas"/>
        </v-toolbar>        

        <v-data-table
            :headers="EncabezadoTablaHerramientas"
            :items="ArrayTodasHerramientas"
            item-key="idHerramienta"
            class="elevation-1"
            :search="buscarRegistro"
            :footer-props="{itemsPerPageText: 'Filas por página'}"                 
            :loading="loading"
            loading-text="Cargando Datos..."    
        >
            <template v-slot:item.puedeSolicitar="{ item }">
                <v-row justify="space-around">
                    <v-tooltip left color="#00b40f" v-if="item.puedeSolicitar">
                        <template v-slot:activator="{ on }">
                            <v-chip v-on="on" color="#00b40f" text-color="white" > 
                                <v-icon>fas fa-check</v-icon>
                            </v-chip>
                        </template>
                        <span class="fontButton">sí puede realizar solicitud</span>
                    </v-tooltip>                    
                    <v-tooltip left color="#d80000" v-if="!item.puedeSolicitar">
                        <template v-slot:activator="{ on }">
                            <v-chip v-on="on" color="#d80000" text-color="white" >
                                <v-icon >fas fa-times-circle</v-icon>
                            </v-chip>
                        </template>
                        <span class="fontButton">Ya tiene una solicitud en proceso</span>
                    </v-tooltip>                    
                </v-row>
            </template>       
            <template v-slot:no-data v-if="ArrayTodasHerramientas.length === 0">
                <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left" v-if="!alertError"
                >
                    No existen solicitudes registradas
                </v-alert>
            </template>                    
            <template v-slot:item.action="{ item }">
                <v-tooltip left color="#000000" v-if="item.puedeSolicitar">
                    <template v-slot:activator="{ on }">
                        <v-btn small class="ml-2" dark fab color="#000000" v-on="on" @click="AbrirModalFormularioSolicitud(item)" >
                            <v-icon small>fas fa-plus-circle</v-icon>
                        </v-btn>                        
                    </template>
                    <span class="fontButton">Agregar Solicitud</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <TablaSolicitudesEnviar :ArrayTodasLasSolicitudesAEnviar="ArrayTodasLasSolicitudesAEnviar" 
            :sucursal="sucursal" :bodega="bodega" :proyecto="proyecto"
            @ObtenerTodasLasHerramientas="ObtenerTodasLasHerramientas"
        />

        <FomrularioSolicitudHerramienta 
            :DialogoFormularioSolicitud="DialogoFormularioSolicitud" @CerrarModalFormularioSolicitud="CerrarModalFormularioSolicitud"
            :ObtenerSolicitudDeHerramienta="ObtenerSolicitudDeHerramienta" :ArrayTodasLasSolicitudesAEnviar="ArrayTodasLasSolicitudesAEnviar"            
        />
    </div>
</template>

<script>
import { showMessageError, showMessageSuccess } from '../../../services/sweetAlert'
import TablaSolicitudesEnviar from '../../../components/Inventario/EnviarSolicitudDeHerramientas/TablaSolicitudesEnviar'
import FomrularioSolicitudHerramienta from '../../../components/Inventario/EnviarSolicitudDeHerramientas/FormularioSolicitudHerramienta'
import BotonActualizarTabla from '../../BotonActualizarTabla'

export default {
    components:{
        TablaSolicitudesEnviar,
        FomrularioSolicitudHerramienta,
        BotonActualizarTabla,
    },
    props:{
        proyecto:Number,
        sucursal:Number,
        bodega:Number,
        tab: String,
    },

    data() {
        return {
            loading: false,
            alertError:false,
            buscarRegistro:'',
            ArrayTodasHerramientas: [],
            EncabezadoTablaHerramientas:[
                {text: 'Tipo Herramienta', value: 'catalogoHerramienta.tipoHerramienta.nombre', sortable: false, align: 'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: 'Nombre', value:'catalogoHerramienta.nombre', sortable: false, align:'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: 'Marca', value: 'catalogoHerramienta.marcaHerramienta.nombre', sortable: false, align: 'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: 'Existencia', value: 'cantidad', sortable: false, align: 'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: '¿Puede Solicitar?', value: 'puedeSolicitar', sortable: false, align: 'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],
            ArraySolicitudesHerramientasAEnviar:[],
            PuedeSolicitar: false,

            ObtenerSolicitudDeHerramienta:{
                idHerramienta:0,
                tipoHerramienta:'',
                nombreHerramienta:'',
                marcaHerramienta:'',
                cantidadSolicitada:0,
                existencia:0,
            },
            ArrayTodasLasSolicitudesAEnviar:[],
            // varibles para el dialogo del formulario de solicitud
            DialogoFormularioSolicitud: false,
            PuedeSolicitar: false,

            alertErrorPost:false,
            arrayErrorPost:[],             
        }
    },
    watch: {
        tab(){
            this.ObtenerTodasLasHerramientas()
        },
        sucursal(){
            this.ObtenerTodasLasHerramientas()
        },
        bodega(){
            this.ObtenerTodasLasHerramientas()
        },
        proyecto(){
            this.ObtenerTodasLasHerramientas()
        }
    },
    created() {
        this.ObtenerTodasLasHerramientas()
    },

    methods: {
        // metodos para el formulario de solicitud de herramienta
        AbrirModalFormularioSolicitud(datos){
            this.ObtenerSolicitudDeHerramienta.idHerramienta = datos.idHerramienta
            this.ObtenerSolicitudDeHerramienta.tipoHerramienta = datos.catalogoHerramienta.tipoHerramienta.nombre
            this.ObtenerSolicitudDeHerramienta.nombreHerramienta = datos.catalogoHerramienta.nombre
            this.ObtenerSolicitudDeHerramienta.marcaHerramienta = datos.catalogoHerramienta.marcaHerramienta.nombre            
            this.ObtenerSolicitudDeHerramienta.existencia = datos.cantidad            
            
            this.DialogoFormularioSolicitud = true
        },
        CerrarModalFormularioSolicitud(){
            this.ObtenerSolicitudDeHerramienta = {}
            this.DialogoFormularioSolicitud = false
        },

        async ObtenerTodasLasHerramientas (){
            this.alertErrorPost=false;this.arrayErrorPost=[];
            this.loading = true
            var data = {proyecto: this.proyecto, sucursal: this.sucursal, bodega: this.bodega}
            const response = await this.$store.dispatch('TodasHerramientasSolicitud', data)
            if(response.status === 200){
                this.alertErrorPost=false;this.arrayErrorPost=[];
                this.ArrayTodasLasSolicitudesAEnviar = []
                this.ArrayTodasHerramientas = response.data
                this.PuedeSolicitar = response.data.puedeSolicitar
                // alert(this.PuedeSolicitar)
                this.loading = false
            }else{
                this.ControlladorExcepciones(response)
            }                                            
        },
        // controlamos la excepcion, y mostramos una alerta cuando el api deja de funcionar
        ControllerException(){
            this.alertError=true
            this.loading=false
        },                        
        // controlamos todas las excepciones http
        ControlladorExcepciones(response){
            if(typeof response === 'undefined'){
                this.ControllerException()
                return 0
            }else if(response.status === 400){
                this.alertErrorPost=true
                var object = response.data.errors
                for (var property in object){
                    this.arrayErrorPost.push({description: `${object[property]}`})
                }
                this.loading = false  
            }else if(response.status === 401){
                showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                this.loading = false                      
            }else if(response.status === 404){
                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                this.loading = false
            }else if(response.status === 500){
                showMessageError('Error 500','Error en el servidor')            
                this.loading = false
            }                
        }              
    },
}
</script>